(function() {
	'use strict';

	angular.module('smb-app')
		.factory('smbDocumentNotesDataStore', ['smbDocumentNotesService', DocumentNotesDataStore]);

	/**
	 * @ngdoc service
	 * @name smb-app.smbDocumentNotesDataStore
	 * 
	 * @description
	 * Manages state for the notes for a single document.
	 */
	function DocumentNotesDataStore(smbDocumentNotesService) {
		var _notes;

		return {
			/**
			 * @ngdoc property
			 * @name smbDocumentNotesDataStore#notes
			 * @propertyOf smb-app.smbDocumentNotesDataStore
			 * @kind property
			 * 
			 * @description
			 * Returns the current collection of notes
			 * 
			 * @returns {DocumentNote[]} An array of @see DocumentNote objects
			 */
			get notes() { return _notes; },

			/**
			 * @ngdoc method
			 * @name smbDocumentNotesDataStore#loadNotes
			 * @propertyOf smb-app.smbDocumentNotesDataStore
			 * @kind function
			 * 
			 * @description
			 * Loads the document notes for a specific document by id
			 * 
			 * @param {String} documentId The document id
			 * 
			 * @returns {Deferred<DocumentNote[]>} A promise that resolves to a collection of @see DocumentNote objects
			 */
			loadNotes: loadNotes,

			createNote: createNote
		};

		function loadNotes(documentId) {
			return smbDocumentNotesService.getNotes(documentId)
				.then(function(notes) {
					notes.reverse();
					_notes = notes;
					return notes;
				});
		}

		function createNote(documentId, note) {
			return smbDocumentNotesService.createNote(documentId, note)
				.then(function(data) {
					if (!_notes) {
						_notes = [];
					}
					_notes.unshift(data);
					return data;
				});
		}
	}

}());


//////////////////
// WEBPACK FOOTER
// ./app/dataStores/documentNotesDataStore.js
// module id = 123
// module chunks = 1